var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5680",
    "data-name": "Group 5680",
    transform: "translate(-0.421)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(0.421)",
    fill: "#3e6dc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M310.9,105.706V116.5H303.85V106.431c0-2.526-1.014-4.256-3.572-4.256a3.843,3.843,0,0,0-3.617,2.287,3.781,3.781,0,0,0-.233,1.522V116.5h-7.046s.1-17.054,0-18.815h7.046v2.67a.3.3,0,0,0-.045.064h.045v-.064a7.16,7.16,0,0,1,6.355-3.108c4.64,0,8.114,2.686,8.114,8.471h0ZM278.44,116.5h7.046V97.681H278.44Zm0,0,7.252-25.207a3.652,3.652,0,1,1-3.626-3.22,3.442,3.442,0,0,1,3.626,3.22Z",
    transform: "translate(-267.366 -75.657)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.69b1f7beac5ab74b7a0cfa6c490e212d.svg";
export { ForwardRef as ReactComponent };